module.exports = __webpack_public_path__ + "static/media/prizes-front.37ebf62c.svg";